export default "__VITE_ASSET__cdb9149b__"